import { Toaster } from 'react-hot-toast';
import { BrowserRouter } from 'react-router-dom';
import Routes from './routes';
import Nav from './pages/Landing/Components/Personal/Nav';
import Footer from './pages/Landing/Components/Personal/Footer';
import { WhatsappIconExpandable } from './components/ui/WhatsappExpandable';
import './styles/App.scss';
import './lib/axios';

export const openWhatsapp = () => {
  window.open('https://wa.me/2349044556688?text=Hello%20Pensphere%20');
};

function App() {
  return (
    <BrowserRouter>
      <div className="app relative">
        <Nav />
        <Toaster
          position="top-center"
          reverseOrder={false}
          containerStyle={{ zIndex: 10000 }}
        />
        <Routes />
        <Footer />
        <WhatsappIconExpandable />
      </div>
    </BrowserRouter>
  );
}

export default App;
